import { useAuth } from '../features/auth/hooks/useAuth';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { RecentPacketList } from '../features/dashboard/components/RecentPacketList';
import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { RoleType, type User } from '@promo/shared';

export function DashboardPage() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const { user } = session;

  // Fetch global managers and senior leaders to determine if user can create packets
  const { data: managers = [], isLoading: managersLoading } = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.MANAGER],
    queryFn: () => get<User[]>('/users', { role: RoleType.MANAGER }),
  });
  const { data: seniorLeaders = [], isLoading: seniorLeadersLoading } = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.SENIOR_LEADER],
    queryFn: () => get<User[]>('/users', { role: RoleType.SENIOR_LEADER }),
  });
  const canCreate = !managersLoading && !seniorLeadersLoading
    && (managers.some(u => u.id === user?.id) || seniorLeaders.some(u => u.id === user?.id));

  // TODO: Add a loading state or redirect if user is not available initially
  if (!user) return null;

  // Get first name if available, otherwise fallback to email
  const firstName = user.name?.split(' ')[0];
  const displayName = firstName || user.email;

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Top Greeting */}
      <h1 className="text-3xl font-semibold mb-16">What's up, {displayName}!</h1>

      {/* Main Dashboard Content Area */}
      <div>
        {/* Row for Recent Header and New Packet Button */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Recent</h2>
          {canCreate && <Button onClick={() => navigate('/packets/new')}>New Packet</Button>}
        </div>

        {/* Recent Packets List (Chunk 2) */}
        <RecentPacketList />
      </div>
    </div>
  );
} 